export class ApiError extends Error {
    constructor(code = 400, message = "Something went wrong, try again shortly") {
        super(message);
        this.name = "ApiError";
        this.message = message;
        this.code = code;
    }
    static create(args) {
        const e = new ApiError(args.code, args.message);
        e.url = args.url;
        e.response = args.response;
        return e;
    }
}
//# sourceMappingURL=index.js.map